import {
    IWorkflowNode,
    resourceNameWorkflowNode,
} from "motw_core/Entity/IWorkflowNode";
import { homeNode } from "motw_core/Repositories/WorkflowRepository";
import { SortFavoriteNodesByLastModifiedTime } from "source/app/presentation/MainPanel/Workflows/Helpers/SortFavoriteNodesByLastModifiedTime";
import { GetWorkflowsState } from "source/app/presentation/MainPanel/Workflows/Workflows";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";

export async function TouchWorkflowNodeParentsAsync(
    parentIds: Array<number | null | undefined>
) {
    const parentIdsToTouch = GetWorkflowNodeIdsToTouch(parentIds);
    const lastModifiedTime = new Date().toISOString();

    if (parentIdsToTouch.length > 0) {
        await ClientDataProvider.UpdateRecordAsync(
            `${resourceNameWorkflowNode}?id=in.(${parentIdsToTouch.join(",")})`,
            { lastmodifiedtime: lastModifiedTime }
        );

        UpdateWorkflowNodeTimestampsLocally(
            parentIdsToTouch,
            lastModifiedTime
        );
    }

    return lastModifiedTime;
}

export function UpdateWorkflowNodeStateLocally(
    node: IWorkflowNode,
    changes: Partial<IWorkflowNode>,
    lastModifiedTime: string
) {
    const workflows = GetWorkflowsState();

    if (!workflows) {
        return;
    }

    const updateNode = (existingNode: IWorkflowNode) =>
        existingNode.id === node.id
            ? {
                  ...existingNode,
                  ...changes,
                  lastmodifiedtime: lastModifiedTime,
              }
            : existingNode;

    const updatedNode = {
        ...node,
        ...changes,
        lastmodifiedtime: lastModifiedTime,
    };

    let favoriteNodes = workflows.state.favoriteNodes.filter(
        (favoriteNode) =>
            favoriteNode.id !== node.id || updatedNode.isfavorite !== false
    );

    if (updatedNode.isfavorite) {
        const hasUpdatedFavorite = favoriteNodes.some(
            (favoriteNode) => favoriteNode.id === node.id
        );

        favoriteNodes = hasUpdatedFavorite
            ? favoriteNodes.map(updateNode)
            : [updatedNode, ...favoriteNodes];
    }

    workflows.setState({
        visibleNodes: workflows.state.visibleNodes.map(updateNode),
        favoriteNodes: SortFavoriteNodesByLastModifiedTime(favoriteNodes),
    });
}

function UpdateWorkflowNodeTimestampsLocally(
    nodeIds: number[],
    lastModifiedTime: string
) {
    const workflows = GetWorkflowsState();

    if (!workflows) {
        return;
    }

    const touchedNodeIds = new Set(nodeIds);
    const updateTimestamp = (node: IWorkflowNode) =>
        touchedNodeIds.has(node.id)
            ? { ...node, lastmodifiedtime: lastModifiedTime }
            : node;

    workflows.setState({
        visibleNodes: workflows.state.visibleNodes.map(updateTimestamp),
        favoriteNodes: SortFavoriteNodesByLastModifiedTime(
            workflows.state.favoriteNodes.map(updateTimestamp)
        ),
    });
}

function GetWorkflowNodeIdsToTouch(
    parentIds: Array<number | null | undefined>
) {
    return Array.from(
        new Set(
            parentIds.filter(
                (parentId): parentId is number =>
                    typeof parentId === "number" && parentId !== homeNode.id
            )
        )
    );
}
